/** 品质控制分支 **/
import Layout from "@/views/layout/Layout";
const qualityControlRouter = {
    path: "/qualityControl",
    component: Layout,
    redirect: "/examMan/course/list",
    name: "qualityControl",
    meta: {
        title: "品质控制",
        icon: "qualityControl",
        roles: ["pinzhikongzhi"]
    },

    children: [
        {
            path: 'checkFeedbackRecords',
            component: () => import('@/views/qualityControl/checkFeedbackRecords/index'),
            name: 'checkFeedbackRecords',
            meta: {
                title: '检查反馈记录',
                roles: ['pzkz_jianchafankuijilu']
            },
            children: []
        },
        {
            path: 'checkFeedbackManagement',
            name: 'checkFeedbackManagement',
            component: () => import('@/views/qualityControl/checkFeedbackManagement/index'),
            meta: {
                title: '检查反馈管理',
                permission: ['pzkz_jianchafankuiguanli']
            }
        },
        {
            path: 'satisfactionScore',
            name: 'satisfactionScore',
            component: () => import('@/views/qualityControl/satisfactionScore/index'),
            meta: {
                title: '满意度评分',
                roles: ['pzkz_manyidupingfen']
            }
        }
    ]
};

export default qualityControlRouter;